
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router }   from '@angular/router';
import { UserService } from '../../services/user.service';
import { User } from "../../models/user";
import { Alert } from "../../models/alert";
import { Machine } from "../../models/machine";
import { AlertPreference } from "../../models/alert-preference";
import { AccountService} from "../../services/account.service";
import { AlertService } from "../../services/alerts.service";
import {Account} from "../../models/account";
import {ToastsManager} from 'ng2-toastr/ng2-toastr';

@Component({
    selector: 'user-detail',
    templateUrl: 'user-detail.component.html',
    styleUrls: ['user-detail.component.scss'],
    moduleId: module.id

})

export class UserDetailComponent implements OnInit{
    private modalHide = [true];
    user: User;
    alerts: Alert[];
    addressDisplay: string = "";
    loading: boolean = true;
    availableMachines: any[] = [];
    activeAlerts: AlertPreference[] = [];
    baseAlerts: AlertPreference[] = [];
    loggedInUser: User = new User();
    loggedInUserRole: string = "";
    userAccount: Account = new Account();
    accounts: Account[];
    accountRoles: Array<object> =
        [
            {
                name: 'Admin',
                value: 'accountAdmin'
            },
            {
                name: 'Member',
                value: 'accountMember'
            }
        ];

    constructor(
        private userService: UserService,
        private route: ActivatedRoute,
        private router: Router,
        private accountService: AccountService,
        private alertService: AlertService,
        private toastr: ToastsManager
    ) {}

    ngOnInit(): void {
        this.loggedInUserRole = this.userService.accountRole;
        let userid = this.userService.userId;
        this.userService.get(userid).then(user => {
            if (!user) {
                return;
            }
            this.loggedInUser = user;
            /*this.userService.getAccountForUser(user.id).then(account => {
                this.userAccount = account;
            });*/
        });

        this.route.params.forEach((params: Params) => {
            let me = this;
            let id = params['id'];
            this.userService.get(id)
            .then(user => {
                this.user = user;
                if (user.street && user.city && user.state && user.zip) {
                    this.addressDisplay = `${user.street}, ${user.city} ${user.state} ${user.zip}`;
                }

                for (let alertPref of user.defaultAlertPreferences) {
                    let activeNotifications: string[] = [];

                    if (alertPref.email) {
                        activeNotifications.push("Email")
                    }

                    if (alertPref.textMessage) {
                        activeNotifications.push("Text")
                    }

                    //if (alert.pushNotification) {
                    //    activeNotifications.push("Push")
                    //}

                    alertPref.notificationDisplay = activeNotifications.join(", ");
                    //alert.allSelected = alert.pushEnabled && alert.emailEnabled && alert.textEnabled;
                    alertPref.allSelected = alertPref.email && alertPref.textMessage;
                }

                this.alertService.getBaseAlerts().then(alerts => {
                    this.alerts = alerts;
                    alerts.forEach(alert => {
                        let pref = new AlertPreference();
                        pref.alertId = alert.id;
                        pref.name = alert.name;
                        pref.machineId = null;
                        this.baseAlerts.push(pref);
                        if (this.user.defaultAlertPreferences) {
                            let found = false;
                            this.user.defaultAlertPreferences.forEach(dap => {
                                if (pref.alertId === dap.alertId) {
                                    found = true;
                                }
                            });
                            if (!found) {
                                this.user.defaultAlertPreferences.push(pref);
                            }
                        }
                    });
                    if (!this.user.defaultAlertPreferences || !this.user.defaultAlertPreferences.length) {
                        this.user.defaultAlertPreferences = this.baseAlerts;
                    }
                    this.activeAlerts = this.user.defaultAlertPreferences;
                });
                this.accountService.machines().then(function(machines){
                    for (let machine of machines) {
                        let availableMachine = {
                            id: machine.id,
                            name: machine.name,
                            serialNumber: machine.serialNumber,
                            //computed fields, just for this view
                            selected: false,
                            //role is Owner, Tech, Employee
                            role: "",
                            isOwner: false,
                            isEmployee: false,
                            isTech: false
                        };

                        for (let machine of me.user.assignedMachines) {
                            if (machine.id == availableMachine.id) {
                                availableMachine.selected = true;
                                availableMachine.role = machine.role;
                            }
                        }
                        me.availableMachines.push(availableMachine);
                    }
                });
                this.loading = false;
            });

        });
    }
    getAddress(place: any): void {
        let components: any = place.address_components;
        let streetNumber: string = "";
        let streetName: string = "";
        for (let component of components) {
            for (let t of component.types) {
                if (t === "route") {
                    streetName = component.long_name;
                }
                if (t === "street_number") {
                    streetNumber = component.long_name;
                }
                if (t === "locality") {
                    this.user.city = component.long_name;
                }
                if (t === "administrative_area_level_1") {
                    this.user.state = component.short_name;
                }
                if (t === "country") {
                    this.user.country = component.short_name;
                }
                if (t === "postal_code") {
                    this.user.zip = component.long_name;
                }
            }
        }
        this.user.street = `${streetNumber} ${streetName}`.trim();
    }

    save(): void {
        //reset the assignedMachines array based on what they've got set up
        this.user.assignedMachines = [];
        for (let machine of this.availableMachines) {
            if (machine.selected) {
                let m = new Machine();
                m.id = machine.id;
                m.role = machine.role;
                this.user.assignedMachines.push(m);
            }
        }
        this.userService.update(this.user).then(result => this.router.navigate(['users']))
    }

    delete(): void {
        let me = this;
        this.userService.delete(this.user).then(function(result){
            me.router.navigate(['users'])
        });
    }

    resendVerificationEmail(): void {
        let me = this;
        this.userService.resendVerification(this.user)
    }

    selectAll(alertPref: AlertPreference): void {
        if (!alertPref.allSelected) {
            alertPref.email = true;
            //alertPref.pushNotification = true;
            alertPref.textMessage = true;
        } else {
            alertPref.email = false;
            //alertPref.pushNotification = false;
            alertPref.textMessage = false;
        }

    }

    alertChange(checked: boolean, alertPref: AlertPreference): void {
        if (!checked && alertPref.allSelected) {
            alertPref.allSelected = false;
        }
    }

    addMachine(machine: any, checked: boolean): void {
        //set selected to true and add a role of "Owner" if it doesn't already have one
        machine.selected = checked;
        if (!machine.role) {
            machine.role = "Owner";
            machine.isOwner = true;
        }
    }

    selectAllMachines(checked: boolean): void {
        for (let m of this.availableMachines) {
            m.selected = checked;
            this.addMachine(m, checked)
        }
    }

    machineSelected(machineId: string) : void {
        if (machineId == "0") {
            //setting defaultAlerts
            this.activeAlerts = this.user.defaultAlertPreferences;
        } else {
            //do we have alerts for this machine yet?
            let existing: any[] = [];
            for (let prefs of this.user.alertPreferences) {
                if (prefs.machineId === machineId) {
                    existing.push(prefs);
                }
            }
            if (existing && existing.length) {
                for (let alertPref of existing) {
                    let activeNotifications: string[] = [];

                    if (alertPref.email) {
                        activeNotifications.push("Email")
                    }

                    if (alertPref.textMessage) {
                        activeNotifications.push("Text")
                    }

                    //if (alert.pushNotification) {
                    //    activeNotifications.push("Push")
                    //}

                    alertPref.notificationDisplay = activeNotifications.join(", ");
                    //alert.allSelected = alert.pushEnabled && alert.emailEnabled && alert.textEnabled;
                    alertPref.allSelected = alertPref.email && alertPref.textMessage;
                }
                this.activeAlerts = existing;
            } else {
                this.activeAlerts = [];
                //initialize a new alert array
                this.alerts.forEach(alert => {
                    let pref = new AlertPreference();
                    pref.alertId = alert.id;
                    pref.machineId = machineId;
                    pref.name = alert.name;
                    this.activeAlerts.push(pref);
                    this.user.alertPreferences.push(pref);
                });
            }

        }

    }
}



// WEBPACK FOOTER //
// ./src/app/components/user-detail/user-detail.component.ts